// SCR-010's route (usage adjustments of one customer-month, NAV-005), composed into the route table
// by TASK-140. SCR-009 (commercial terms) is no longer a route of its own: it is the customer
// page's Billing tab (`/customers/:orgId/billing`, screens/orgs; billing-tab.tsx here), which the
// legacy `/rate-plans/orgs/:orgId` address redirects to.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { Adjustments } from "./adjustments";

export const routes: ScreenRoute[] = [
  defineRoute({
    nav: "NAV-005",
    path: "/customers/:orgId/invoices/:period/adjustments",
    title: "Usage adjustments",
    permission: "billing:read",
    component: Adjustments,
  }),
];
